<div
	*ngIf="projecthoursEnabled$ | async"
	class="flex flex-col items-center justify-end gap-3"
>
	<div class="flex items-end justify-end space-x-2">
		@if (switchEnabled() === true) {
		<div class="mb-2 flex items-center space-x-2">
			<button
				(click)="onSwitch.emit('comego')"
				[disabled]="isLoading"
				[matTooltip]="'Swap to working hour times'"
				color="light"
				mat-icon-button
				mat-raised-button
				matTooltipPosition="left"
			>
				<mat-icon>swap_horizontal</mat-icon>
			</button>
		</div>
		}
		<div class="flex flex-col items-center justify-end gap-3">
			<button
				(click)="openCreateDialog()"
				[disabled]="!canAdd || isLoading"
				[matTooltip]="'timer.widget.create' | translate"
				color="primary"
				mat-mini-fab
			>
				<mat-icon>add</mat-icon>
			</button>
			<ng-container *ngIf="this.timeRunning$ | async as tr">
				<button
					(click)="delete(tr.id)"
					[disabled]="isLoading"
					[matTooltip]="'time.delete' | translate"
					class="bg-red-500 text-white"
					mat-mini-fab
					matTooltipPosition="left"
				>
					<mat-icon>delete</mat-icon>
				</button>
			</ng-container>
			<ng-container
				*ngTemplateOutlet="
          this.isLoading ? loadingFab : normalFabTimer;
          context: {
            time: timeRunning$ | async,
            timeDisabled: stopDisabled$ | async,
          }
        "
			></ng-container>
		</div>
	</div>
	<ng-template
		#runningFabTimer
		let-time="time"
	>
		<button
			(click)="stopRecord()"
			color="accent"
			mat-raised-button
		>
			<div class="line-height-base -ml-3 -mr-1 flex h-10 flex-row items-center justify-start gap-1">
				<mat-icon>stop</mat-icon>
				{{ time.start | dfnsParseIso | dfnsDifferenceInSeconds: time.now | parseMsAsDuration: false }}
			</div>
		</button>
	</ng-template>
	<ng-template
		#normalFabTimer
		let-time="time"
		let-timeDisabled="timeDisabled"
	>
		<div
			[matTooltipTemplate]="tooltipCounter"
			[matTooltipTemplateContext]="{ time: time, timeDisabled: timeDisabled }"
			matTooltip
			matTooltipPosition="left"
		>
			<button
				(click)="time ? stopRecord() : startRecord()"
				[disabled]="!canAdd || (stopDisabled$ | async)"
				fxHide.lt-lg
				mat-fab
			>
				<mat-icon *ngIf="!time; else runningTime">play_arrow</mat-icon>
				<ng-template #runningTime> <mat-icon>stop</mat-icon> </ng-template>
			</button>
			<div
				class="relative"
				fxHide.gt-md
			>
				<button
					(click)="time ? stopRecord() : startRecord()"
					mat-fab
				>
					<mat-icon *ngIf="!time; else runningTime">play_arrow</mat-icon>
					<ng-template #runningTime> <mat-icon>stop</mat-icon> </ng-template>
				</button>
				<div
					*ngIf="time && !time.end"
					class="mbg-tooltip absolute bottom-0 right-full mr-2 block min-w-48 rounded px-2.5 py-2 text-left shadow"
				>
					<ng-container
						*ngTemplateOutlet="tooltipCounter; context: { time: time, timeDisabled: timeDisabled }"
					></ng-container>
				</div>
			</div>
		</div>
	</ng-template>
	<ng-template
		#loadingFab
		let-time="time"
	>
		<button
			disabled
			mat-fab
		>
			<mat-progress-spinner
				[diameter]="20"
				[mode]="'indeterminate'"
				[strokeWidth]="3"
				color="accent"
			></mat-progress-spinner>
		</button>
	</ng-template>
</div>
<ng-template
	#tooltipCounter
	let-time="time"
	let-timeDisabled="timeDisabled"
>
	<ng-container *ngIf="time && !time.end; else tooltipRecordAction">
		<div class="flex flex-col space-y-2.5">
			<ng-container *ngIf="timeDisabled">
				<div class="pt-0.5">{{ 'time.min-hint' | translate }}</div>
				<mat-divider inline></mat-divider>
			</ng-container>
			<div class="flex flex-row items-center justify-start gap-2">
				<mat-icon>timer</mat-icon>
				<div class="flex flex-col">
					<span class="font-bold">{{ time.name }}</span>
					<div class="flex flex-row items-center justify-start gap-1">
						<span
							*ngIf="time.project as project"
							class="op-70 text-sm font-bold"
							>{{
								project | defaultEntityTranslate: 'project' : 'project.none'
							}}</span
						>
						<ng-container *ngIf="time.task?.name as taskName">
							<div class="mat-bg-30 h-1 w-1 flex-shrink-0 rounded-full"></div>
							<span class="op-70 truncate text-sm">{{ taskName | truncate: 35 }}</span>
						</ng-container>
					</div>
					<span class="mt-1">{{
						time.start | dfnsParseIso | dfnsDifferenceInSeconds: (now$ | async)  | parseMsAsDuration: false
					}}</span>
				</div>
			</div>
		</div>
	</ng-container>
	<ng-template #tooltipRecordAction>{{ 'timer.widget.start' | translate }}</ng-template>
</ng-template>
